import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { FormControl, RadioGroup } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  label: {
    marginRight: '20px'
  },
  containerRadio: {
    display: 'flex',
    flexDirection: 'row'
  }
});
export default function CustomRadioButton ({ value, listItem, onChange, radioProps }) {
  const classes = useStyles();
  const [state, setState] = React.useState(value);
  const { t } = useTranslation();

  const handleChange = (event) => {
    setState(event.target.value);
    onChange(event.target.value);
  };

  return (
    <FormControl className={classes.container}>
      <RadioGroup className={classes.containerRadio} value={state} onChange={handleChange} >
        {listItem.map((item) => (
          <FormControlLabel key={item.value} value={item.value} control={<Radio {...radioProps} />} label={t(`exportData:${item.label}`)} />
        ))}
      </RadioGroup>
    </FormControl>
  );
}

CustomRadioButton.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  listItem: PropTypes.array.isRequired,
  radioProps: PropTypes.object
};
